import { render } from "./PaginatedClaimList.vue?vue&type=template&id=e68b26b8"
import script from "./PaginatedClaimList.vue?vue&type=script&lang=js"
export * from "./PaginatedClaimList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__